"use strict";
// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=contentful.js.map